import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import WorkPage from './pages/WorkPage';
import ProjectPage from './pages/ProjectPage';
import AboutPage from './pages/AboutPage';
import ManifestoPage from './pages/ManifestoPage';
import ConnectPage from './pages/ConnectPage';
import FloatingTextBar from './components/FloatingTextBar';
import PageTransition from './components/PageTransition';
import LoadingScreen from './components/LoadingScreen';
import ScrollToTop from './components/ScrollToTop';
import DitheringBackground from './components/DitheringBackground';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // Set current year in footer
  useEffect(() => {
    const yearElement = document.getElementById('year');
    if (yearElement) {
      yearElement.textContent = new Date().getFullYear();
    }
  }, []);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingScreen onComplete={handleLoadingComplete} />;
  }

  return (
    <Router>
      <ScrollToTop />
      <DitheringBackground />
      <PageTransition>
        <div className="App">
          <Header />
          <FloatingTextBar />
          
                                <main className="main-content">
                        <Routes>
                          <Route path="/" element={<Navigate to="/work" replace />} />
                          <Route path="/work" element={<WorkPage />} />
                          <Route path="/work/:projectSlug" element={<ProjectPage />} />
                          <Route path="/about" element={<AboutPage />} />
                          <Route path="/manifesto" element={<ManifestoPage />} />
                          <Route path="/connect" element={<ConnectPage />} />
                        </Routes>
                      </main>
        </div>
      </PageTransition>
    </Router>
  );
}

export default App; 